module.exports = __webpack_public_path__ + "img/cat-07.8e2aff42.png";